import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/vehicledriverinfoserv'

export default {
  state: {
    state_VehicleDriverInfo_AddObjResult: null,
    state_VehicleDriverInfo_GetAllResult: null,
    state_VehicleDriverInfo_GetPageResult: null,
    state_VehicleDriverInfo_GetDetailResult: null,
    state_VehicleDriverInfo_ModifyObjResult: null,
    state_VehicleDriverInfo_DeleteObjResult: null
  },
  mutations: {
    SET_VEHICLEDRIVERINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleDriverInfo_AddObjResult = rst
    },
    SET_VEHICLEDRIVERINFO_GETALL_RESULT: (state, rst) => {
      state.state_VehicleDriverInfo_GetAllResult = rst
    },
    SET_VEHICLEDRIVERINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleDriverInfo_GetPageResult = rst
    },
    SET_VEHICLEDRIVERINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleDriverInfo_GetDetailResult = rst
    },
    SET_VEHICLEDRIVERINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleDriverInfo_ModifyObjResult = rst
    },
    SET_VEHICLEDRIVERINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleDriverInfo_DeleteObjResult = rst
    }
  },
  actions: {
    VehicleDriverInfoServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEDRIVERINFO_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEDRIVERINFO_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleDriverInfoServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEDRIVERINFO_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEDRIVERINFO_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleDriverInfoServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEDRIVERINFO_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEDRIVERINFO_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleDriverInfoServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEDRIVERINFO_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEDRIVERINFO_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleDriverInfoServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEDRIVERINFO_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEDRIVERINFO_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleDriverInfoServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEDRIVERINFO_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEDRIVERINFO_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_VehicleDriverInfo_AddObjResult: state => {
      return state.state_VehicleDriverInfo_AddObjResult
    },
    get_VehicleDriverInfo_GetAllResult: state => {
      return state.state_VehicleDriverInfo_GetAllResult
    },
    get_VehicleDriverInfo_GetPageResult: state => {
      return state.state_VehicleDriverInfo_GetPageResult
    },
    get_VehicleDriverInfo_GetDetailResult: state => {
      return state.state_VehicleDriverInfo_GetDetailResult
    },
    get_VehicleDriverInfo_ModifyObjResult: state => {
      return state.state_VehicleDriverInfo_ModifyObjResult
    },
    get_VehicleDriverInfo_DeleteObjResult: state => {
      return state.state_VehicleDriverInfo_DeleteObjResult
    }
  }
}
